import React from 'react'

interface ISpaceProps {
    m?: string,
    mt?: number,
    mb?: number,
    ml?: number,
    mr?: number,
    p?: string,
    pt?: number,
    pb?: number,
    pl?: number,
    pr?: number,
    children?: React.ReactNode;
    style?: React.CSSProperties
}

export const Space = ({
    m,
    mt = 0,
    mb = 0,
    ml = 0,
    mr = 0,
    p,
    pt = 0,
    pb = 0,
    pl = 0,
    pr = 0,
    children,
    style
}: ISpaceProps) => {
    return (
        <div style={{
            margin: m,
            padding: p,
            marginTop: mt,
            marginBottom: mb,
            marginLeft: ml,
            marginRight: mr,
            paddingTop: pt,
            paddingBottom: pb,
            paddingLeft: pl,
            paddingRight: pr,
            ...style
        }} >
            {children}
        </div>
    )
}
